// extracted by mini-css-extract-plugin
module.exports = {"section":"service-cards-module--section--3k_HR","description":"service-cards-module--description--3304l"};